// Laveston — Free Shipping Progress Bar
// Tracks cart total and shows progress toward the free-shipping threshold.

(function () {
  if (customElements.get('laveston-rewards-bar')) return;

  const FREE_SHIP = 7000;
  const POLL_MS   = 1500;
  const GIFT_PROP = '_gift';

  let lastTotal = null;

  const money = (cents) => {
    const d = cents / 100;
    return '$' + (d % 1 === 0 ? d.toFixed(0) : d.toFixed(2));
  };

  class LavestonRewardsBar extends HTMLElement {
    constructor() {
      super();
      this.pollId = null;
    }

    connectedCallback() {
      if (lastTotal !== null) this.render(lastTotal);
      this.refresh();
      this.startPolling();

      ['cart:update', 'cart:refresh', 'cart:added', 'cart:change'].forEach((e) =>
        document.addEventListener(e, this.handleCartEvent)
      );
    }

    disconnectedCallback() {
      this.stopPolling();
      ['cart:update', 'cart:refresh', 'cart:added', 'cart:change'].forEach((e) =>
        document.removeEventListener(e, this.handleCartEvent)
      );
    }

    handleCartEvent = () => this.refresh();

    startPolling() {
      this.stopPolling();
      this.pollId = setInterval(() => this.refresh(), POLL_MS);
    }

    stopPolling() {
      if (this.pollId) { clearInterval(this.pollId); this.pollId = null; }
    }

    async refresh() {
      try {
        const res = await fetch('/cart.js', {
          headers: { Accept: 'application/json' },
          cache: 'no-store'
        });
        if (!res.ok) return;
        const cart = await res.json();
        const items = cart.items || [];
        lastTotal = this.#eligibleTotal(cart.total_price || 0, items);
        this.render(lastTotal);
      } catch (_) { /* mid-morph, ignore */ }
    }

    #eligibleTotal(total, items) {
      const giftValue = items
        .filter((i) => {
          const p = i.properties || {};
          return p[GIFT_PROP] === 'true' || p[GIFT_PROP] === true;
        })
        .reduce((s, i) => s + (i.final_line_price || 0), 0);
      return Math.max(0, total - giftValue);
    }

    render(total) {
      const shipOk = total >= FREE_SHIP;
      const fillPct = Math.min(100, (total / FREE_SHIP) * 100);

      const fill = this.querySelector('[data-lrb-fill]');
      if (fill) fill.style.width = fillPct + '%';

      const marker = this.querySelector('[data-lrb-marker="ship"]');
      const label = this.querySelector('[data-lrb-label="ship"]');
      [marker, label].forEach((el) => {
        if (!el) return;
        if (shipOk) el.setAttribute('data-reached', 'true');
        else el.removeAttribute('data-reached');
      });

      let state, caption;
      if (!shipOk) {
        state = 'pre-ship';
        caption = `You're <strong>${money(FREE_SHIP - total)}</strong> away from free shipping`;
      } else {
        state = 'ship';
        caption = 'You\'ve unlocked <strong>free shipping!</strong>';
      }
      this.setAttribute('data-state', state);

      const captionEl = this.querySelector('[data-lrb-caption]');
      if (captionEl) captionEl.innerHTML = caption;
    }
  }

  customElements.define('laveston-rewards-bar', LavestonRewardsBar);
})();
